module.exports = __webpack_public_path__ + "img/dl9.80277e90.png";